import { Resources } from 'constants/resources';

import { useState } from 'react';

import { useNotify, useRedirect } from 'react-admin';
import { CancelButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { TypographyBold } from 'shared/mui/Typography/TypographyBold';
import { CreateGuesserPage } from 'shared/react-admin/Pages/CreateGuesserPage/CreateGuesserPage';
import { User } from 'types/embedded/user';

import { UsersCreateForm } from './UsersCreateForm';

export const UsersCreate = (): JSX.Element => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [hasCorporateEmail, setHasCorporateEmail] = useState(false);

  const transform = (data: User) => {
    return {
      ...data,
      corporateEmail: hasCorporateEmail ? data.corporateEmail : null,
      roleEntities: data.roleEntities,
    };
  };

  const onSuccess = (user: User) => {
    notify(
      <>
        Пользователь <TypographyBold text={`${user.firstName} ${user.lastName}`} /> создан
      </>,
      { type: 'success' },
    );
    redirect('list', Resources.Users);
  };

  return (
    <CreateGuesserPage
      listName="Пользователи"
      mutationOptions={{ onSuccess, onError: () => undefined }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButtonValidated key="save-buttton" label="Создать" />,
      ]}
      title="Создание пользователя"
      transform={transform}
    >
      <UsersCreateForm
        hasCorporateEmail={hasCorporateEmail}
        setHasCorporateEmail={setHasCorporateEmail}
      />
    </CreateGuesserPage>
  );
};
